// Exact role name issued in the backoffice JWT; the backend checks the same name.
export const DATA_VERIFIER_ROLE = "Data Verifier";

// Role names carried in a backoffice JWT (payload role.role). Read client-side
// only to choose what to show; the backend verifies the token on every call.
export const getTokenRoles = (token) => {
  try {
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const roles = JSON.parse(atob(payload))?.role?.role;
    return Array.isArray(roles) ? roles : [];
  } catch (e) {
    return [];
  }
};

// A session whose only role is Data Verifier may use candidate verification
// and nothing else (the backend enforces the same rule on its APIs).
export const isDataVerifierOnly = (roles) =>
  Array.isArray(roles) && roles.length > 0 && roles.every((r) => r === DATA_VERIFIER_ROLE);

// Exact role name issued in the backoffice JWT; the backend checks the same name.
export const ADMIT_CARD_VERIFIER_ROLE = "Admit Card Verifier";

// A session whose only role is Admit Card Verifier may use Admit Card
// Verification and nothing else (backend: middleware/authorization.js).
export const isAdmitCardVerifierOnly = (roles) =>
  Array.isArray(roles) && roles.length > 0 && roles.every((r) => r === ADMIT_CARD_VERIFIER_ROLE);

// Exact role name issued in the backoffice JWT; mhcet-notification-service checks the same
// name (NOTIFICATION_ALLOWED_ROLES) on its email template / send / job APIs.
export const NOTIFICATION_ROLE = "Notification";
